 
const LazyLoading = () => {
  return (
    <div role='status' className='d-flex justify-content-center align-items-center py-5'>
      <span className='spinner-border spinner-border-sm text-theme me-2' aria-hidden='true'></span>
      <span className='visually-hidden'>جاري التحميل...</span>
    </div>
  );
};

export default LazyLoading;
